import { Component, Inject, Input, Optional } from '@angular/core';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { ReferencePriceTypes } from '~shared/models/reference-price-types.enum';
import { Observable } from 'rxjs/internal/Observable';
import { PriceTypeService } from '~shared/modules/price-type-toggler/services';
import { Product } from '~shared/models';
import { CountryCode, NUMBER_0, NUMBER_1 } from '~shared/constants';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { REQUEST } from '@nguniversal/express-engine/tokens';

@Component({
  selector: 'app-search-variants-price',
  templateUrl: './variants-price.component.html',
  styleUrls: ['./variants-price.component.scss'],
})
export class VariantsPriceComponent {
  @Input() product: Product;
  @Input() saveTotalUnitsOrBasePriceSpace: boolean;
  priceType$: Observable<PriceTypes>;
  priceTypes = PriceTypes;
  referencePriceTypes = ReferencePriceTypes;
  isUserB2B: boolean;
  singleUnit: boolean;
  multiUnit: boolean;
  msrpTypeProductReference: boolean;
  msrpTypeUnitPriceReference: boolean;
  number_0 = NUMBER_0;
  userCountry: string;
  priceSeperator: string;
  constructor(
    private priceTypeService: PriceTypeService,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any
  ) {}

  protected readonly PriceTypes = PriceTypes;
  protected readonly ReferencePriceTypes = ReferencePriceTypes;

  ngOnInit() {
    this.userCountry = getCountryDomainCode(this.webAppBuyerRequest);
    this.priceSeperator = this.userCountry === CountryCode.Netherlands ? 'per' : '/';
    this.singleUnit = this.product?.bestOffer?.unitPrice?.unitCount === NUMBER_1;
    this.multiUnit = this.product?.bestOffer?.unitPrice?.unitCount > NUMBER_1;
    this.msrpTypeProductReference =
      this.product?.bestOffer?.referencePrice?.priceType === this.referencePriceTypes.MSRP;
    this.msrpTypeUnitPriceReference =
      this.product?.bestOffer?.unitPrice?.referencePrice?.priceType === this.referencePriceTypes.MSRP;
    this.priceType$ = this.priceTypeService.priceType$;
    this.priceType$.subscribe((priceType: PriceTypes) => {
      this.isUserB2B = priceType === PriceTypes.b2b;
    });
  }
}
